import { render } from "./UserList.vue?vue&type=template&id=4daa390c"
import script from "./UserList.vue?vue&type=script&lang=js"
export * from "./UserList.vue?vue&type=script&lang=js"
script.render = render

export default script